import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getAIPromptMastersList = async () => {
  return await axiosInstance.get("ai/prompt-masters/getlist", { headers });
};

export const getAIPromptMasterById = async (id) => {
  const response = await axiosInstance.get(`ai/prompt-masters/get/${id}`, {
    headers,
  });
  return response.data.result;
};

export const addAIPromptMaster = async (payload) => {
  return await axiosInstance.post("ai/prompt-masters/add", payload, { headers });
};

export const updateAIPromptMaster = async (payload) => {
  return await axiosInstance.put("ai/prompt-masters/update", payload, {
    headers,
  });
};

export const deleteAIPromptMaster = async (id) => {
  return await axiosInstance.delete(`ai/prompt-masters/delete/${id}`, {
    headers,
  });
};
